import { ValidationStepProps } from "./schema-validation-progress-bar";

const calculateBatchSizeBasedOnCount = totalCount => {
    if (!Number.isFinite(totalCount) || totalCount <= 0) {
        return 0;
    }

    if (totalCount <= 20) {
        return totalCount; // no batching
    }

    return 20;
};
export const executeValidationMethods = async (
    step: ValidationStepProps,
    schemasToValidate,
    setPercentage,
    setValidationErrs,
    signal: AbortSignal,
    setCompletedCount
) => {
    let completed = 0;
    let hasErrors = false;
    step.errors = step.errors || false;

    const total = schemasToValidate.length;

    const updatePercentage = async () => {
        if (signal.aborted) return;
        const percentage = Math.round((completed / total) * 100);
        await new Promise(requestAnimationFrame);
        setPercentage(percentage);
        setCompletedCount(completed);
    };

    const processSchema = async schema => {
        if (signal.aborted) return;
        const schemaId = schema.get("id");
        try {
            await step.method(schema);
        } catch (err) {
            if (signal.aborted) return;
            hasErrors = true;
            setValidationErrs(prev => {
                const newError = {
                    id: schemaId,
                    schemaName: schema.get("schemaName"),
                    message: err.message || err.toString(),
                    step: step.title
                };
                const insertIndex = prev.findIndex(item => item.id > schemaId);
                if (insertIndex === -1) {
                    return [...prev, newError];
                }
                return [...prev.slice(0, insertIndex), newError, ...prev.slice(insertIndex)];
            });
        } finally {
            completed++;
            await updatePercentage();
        }
    };

    const dynamicBatchSize = calculateBatchSizeBasedOnCount(total);
    for (let i = 0; i < schemasToValidate.length; i += dynamicBatchSize) {
        if (signal.aborted) return;
        const batch = schemasToValidate.slice(i, i + dynamicBatchSize);
        const batchPromises = batch.map(schema => processSchema(schema));
        await Promise.allSettled(batchPromises);
    }
    step.errors = hasErrors;
};
